var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8778_13016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1533 15.1533L1.84667 1.84668L1.33333 1.33335L0.846667 0.84668L0 1.69335L2.92667 4.62001L4.4 7.72668L3.5 9.36001C3.39333 9.54668 3.33333 9.76668 3.33333 10C3.33333 10.7333 3.93333 11.3333 4.66667 11.3333L9.64 11.3333L10.56 12.2533C10.3311 12.4175 10.1601 12.6499 10.0717 12.9174C9.98326 13.1848 9.98192 13.4734 10.0679 13.7416C10.1538 14.0098 10.3226 14.2439 10.55 14.4101C10.7774 14.5764 11.0517 14.6662 11.3333 14.6667C11.78 14.6667 12.1733 14.4467 12.4133 14.1067L14.3067 16L15.1533 15.1533ZM4.94667 10C4.85333 10 4.78 9.92668 4.78 9.83335L4.8 9.75335L5.4 8.66668L6.97333 8.66668L8.30667 10L4.94667 10ZM10.3667 8.66668C10.8667 8.66668 11.3067 8.39335 11.5333 7.98001L13.92 3.65335C13.975 3.5516 14.0027 3.43733 14.0003 3.3217C13.998 3.20606 13.9656 3.09302 13.9065 2.99361C13.8474 2.89419 13.7635 2.81181 13.6631 2.75451C13.5626 2.69721 13.449 2.66695 13.3333 2.66668L4.36 2.66668L10.3667 8.66668ZM4.66667 12C3.93333 12 3.34 12.6 3.34 13.3333C3.34 14.0667 3.93333 14.6667 4.66667 14.6667C5.4 14.6667 6 14.0667 6 13.3333C6 12.6 5.4 12 4.66667 12Z",
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8778_13016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/notAvailable.2719799b6459ae8f9c7a207483f09464.svg";
export { ForwardRef as ReactComponent };